import { useQuery } from "@tanstack/react-query";
import {
  userEvaluationRequestsParams,
  userEvaluationRequestsResponse,
} from "../Models/userEvaluationRequests";
import {
  getUserEvaluationRequestLog,
  getUserEvaluationRequests,
} from "../Api/userEvaluationRequests";

const LIST_REFETCH_INTERVAL = 5000;
const LOG_REFETCH_INTERVAL = 3000;

export const useUserEvaluationRequests = (
  params: userEvaluationRequestsParams
) => {
  return useQuery<userEvaluationRequestsResponse, Error>({
    queryKey: ["userEvaluationRequests", params],
    queryFn: () => getUserEvaluationRequests(params),
    refetchInterval: LIST_REFETCH_INTERVAL,
  });
};

export const useUserEvaluationRequestLog = (id: number, enabled: boolean) => {
  return useQuery({
    queryKey: ["userEvaluationRequestLog", id],
    queryFn: () => getUserEvaluationRequestLog(id),
    enabled: enabled && !!id,
    refetchInterval: enabled ? LOG_REFETCH_INTERVAL : false,
  });
};
